import { Search, BookOpen, Users, Tag, Compass, LayoutGrid } from "lucide-react";

export const EXPLORE_LINKS = [
  { to: "/search", label: "Search", blurb: "Look up a verse, question, person, word or commentary", icon: Search, testId: "explore-menu-search" },
  { to: "/explore", label: "Explore All Questions", blurb: "Browse every question with filters", icon: LayoutGrid, testId: "explore-menu-all" },
  { to: "/explore/books", label: "By Book", blurb: "Genesis to Revelation, in order", icon: BookOpen, testId: "explore-menu-books" },
  { to: "/explore/people", label: "By Asked By / Asked To", blurb: "God, prophets, kings, disciples, everyday people — asking and being asked", icon: Users, testId: "explore-menu-people" },
  { to: "/explore/types", label: "By Type of Question", blurb: "Lament, challenge, invitation, wonder…", icon: Tag, testId: "explore-menu-types" },
  { to: "/explore/themes", label: "By Theme", blurb: "Identity, suffering, faith, purpose", icon: Compass, testId: "explore-menu-themes" },
];

export const FACET_META = {
  people: {
    eyebrow: "Voices of the text",
    title: "Asked by / Asked to",
    intro: "Every question has a person behind it and a person in front of it. Pick anyone to see every question they asked or were asked.",
    itemPath: (name) => `/explore/people/${encodeURIComponent(name)}`,
    noun: "asked or were asked",
  },
  "who-asked": {
    eyebrow: "Voices of the text",
    title: "Who is asking?",
    intro: "Every question has a person behind it. Step into their world and hear how they spoke to God, to each other, and to us.",
    itemPath: (name) => `/explore/who-asked/${encodeURIComponent(name)}`,
    noun: "asked",
  },
  "asked-to": {
    eyebrow: "On the receiving end",
    title: "Who was asked?",
    intro: "Adam hiding in the garden, Cain in the field, Pharaoh on his throne, the disciples in the boat. See who had to answer.",
    itemPath: (name) => `/explore/asked-to/${encodeURIComponent(name)}`,
    noun: "was asked",
  },
  themes: {
    eyebrow: "Threads through Scripture",
    title: "Explore by theme",
    intro: "The same handful of human longings surface again and again. Follow one across the whole Bible.",
    blurbs: {
      "God's Character": "His nature, power, ways, and judgment of the nations",
      "The Identity of Jesus": "Who Jesus is, His authority and mission",
      "Suffering & Lament": "Suffering, grief, waiting, death, and hope",
      "Faith & Fear": "Trust, fear, doubt, and obedience",
      "Sin & Repentance": "Wrongdoing, guilt, confrontation, and turning back",
      "Salvation & Grace": "The gospel, grace, faith vs. works, and resurrection",
      "Wisdom & Justice": "Right living, God's law, justice, and worship practice",
      "Love & Community": "How we treat others, family, and conflict",
      "Identity & Purpose": "Calling, worth, and what life is for",
      "Identity & Calling": "Who God says you are and what He asks of you",
      "Faith & Obedience": "Trusting God enough to act on His word",
      "Suffering & Doubt": "Pain, loss, and the questions they raise",
      "Morality & Law": "Right and wrong, justice, and God's commands",
      "Purpose & Meaning": "Why we are here and what matters",
    },
    itemPath: (name) => `/explore/themes/${encodeURIComponent(name)}`,
    noun: "on this theme",
  },
};
